import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Config } from '../classes/Config';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  static readonly datePipe: DatePipe = new DatePipe(Config.DATE_LOCALE);

  constructor() { }

  transform(value: any, formatType?: any, timezone?: string): any {
    if (!value) {
      return "";
    }
    let format: string = Config.DATE_FORMATS.DATE;
    if (formatType) {
      switch (formatType.toLowerCase()) {
        case "time":
          format = Config.DATE_FORMATS.TIME;
          break;
        case "datetime":
          format = Config.DATE_FORMATS.DATE_TIME;
          break;
        case "fulldate":
          format = Config.DATE_FORMATS.FULL_DATE;
          break;
      }

    }
    return DateFormatPipe.datePipe.transform(value, format, timezone);
  }

}
